var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12043_43624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12043_43624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call_2",
    d: "M19.431 20.4423C17.4861 20.4423 15.5602 19.9807 13.6531 19.0576C11.7461 18.1346 10.0435 16.924 8.54548 15.4259C7.0474 13.9278 5.83522 12.2269 4.90896 10.3231C3.98267 8.41922 3.51953 6.49487 3.51953 4.55C3.51953 4.25 3.61953 4 3.81953 3.8C4.01953 3.6 4.26953 3.5 4.56953 3.5H7.83101C8.08999 3.5 8.31596 3.57981 8.50891 3.73943C8.70184 3.89904 8.82139 4.10513 8.86756 4.3577L9.44063 7.29998C9.48036 7.54613 9.4762 7.76984 9.42813 7.97113C9.38005 8.17241 9.2746 8.34805 9.11178 8.49805L6.81178 10.7461C7.60153 12.0872 8.54321 13.2987 9.63681 14.3808C10.7304 15.4628 11.9682 16.4064 13.3503 17.2115L15.5849 14.9385C15.7477 14.7756 15.9403 14.6599 16.1628 14.5914C16.3852 14.5228 16.6131 14.5083 16.8464 14.5481L19.6233 15.1135C19.8758 15.1699 20.0819 15.292 20.2416 15.4798C20.4012 15.6676 20.481 15.891 20.481 16.15V19.3923C20.481 19.6923 20.381 19.9423 20.181 20.1423C19.981 20.3423 19.731 20.4423 19.431 20.4423ZM6.09258 9.32693L7.87721 7.61923C7.90926 7.59358 7.93009 7.55832 7.93971 7.51345C7.94932 7.46857 7.94771 7.4269 7.93488 7.38845L7.50028 5.15383C7.48745 5.10254 7.46501 5.06408 7.43296 5.03845C7.40091 5.0128 7.35924 4.99998 7.30796 4.99998H5.16951C5.13104 4.99998 5.09898 5.0128 5.07333 5.03845C5.0477 5.06408 5.03488 5.09613 5.03488 5.1346C5.08615 5.81793 5.19801 6.51217 5.37046 7.2173C5.54289 7.92243 5.7836 8.62564 6.09258 9.32693ZM14.7541 17.9115C15.4169 18.2205 16.1082 18.4567 16.8281 18.6202C17.548 18.7836 18.2208 18.8807 18.8464 18.9115C18.8849 18.9115 18.9169 18.8987 18.9426 18.8731C18.9682 18.8474 18.981 18.8153 18.981 18.7769V16.6731C18.981 16.6218 18.9682 16.5801 18.9426 16.548C18.9169 16.516 18.8785 16.4935 18.8272 16.4807L16.7272 16.0538C16.6887 16.041 16.6551 16.0394 16.6262 16.049C16.5974 16.0586 16.5669 16.0795 16.5349 16.1115L14.7541 17.9115Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.316a1d0002cade384c850dc74e349fa7.svg";
export { ForwardRef as ReactComponent };